import { createSelector } from "@reduxjs/toolkit";

const getPayments = (state: any) => state.payments;
const getPaymentsList = createSelector(getPayments, (payments) => payments.list);

export const PaymentsSelectors = {
   getPaymentsList,
};
